import React from 'react';
import SidebarItem from './Sidebar/SidebarItem';
import Button from '../shared/Button';
import '../assets/styles/Sidebar.scss';
import '../assets/styles/_icons.scss';
import { editorURL } from '../utils/editor';
import NewSiteDialog from '../shared/NewSiteDialog';
import { withTracking } from '../shared/Tracking';
import { NavLink, useHistory } from 'react-router-dom';
import HelpDialog from '../shared/HelpDialog';
import ButtonImage from '../assets/images/Button.png';
import FreeImage from '../assets/icons/free.png';
import ThunderIcon from '../assets/images/thunder.png';

function Sidebar(props) {
  const history = useHistory();
  const site = props.site;
  const stripeSubscription = props.stripeSubscription;

  return (
    <div className="sidebar">
      <div
        className={`sidebar-nav-link no-hover ${
          props.isDisable ? 'disabled' : ''
        }`}
      >
        {site && (
          <React.Fragment>
            <ul>
              <div className="new-popup-wrapper" style={{ 
                display: 'flex', 
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                padding: '20px 0'
              }}>
                <NavLink to={editorURL(site, '/new/interstitial')}>
                  <Button
                    variant="contained"
                    className="full-width"
                    style={{ 
                      width: '190px',
                      height: '50px',
                      padding: '0',
                      backgroundColor: '#FFEFE5',
                      border: '2px solid #ED5A29',
                      color: '#ED5A29',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'all 0.2s ease'
                    }}
                    label={
                      <strong>
                        <span style={{ fontWeight: 'bold', marginRight: '8px' }}>+</span>
                        New Popup
                      </strong>
                    }
                  />
                </NavLink>

              </div>

              {/* First Manage label */}
              <div 
                style={{
                  width: '40px',
                  height: '17px',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  color: '#777777',
                  margin: '15px 0 5px 20px',
                  position: 'relative',
                  left: '0px'
                }}
              >
                •&nbsp;Manage
              </div>
              <div style={{ paddingLeft: '15px' }}>  {/* Add padding to match other sidebar items */}
                <SidebarItem
                  name="Summary"
                  path={`/sites/${site.id}/summary`}
                  className="icon-manage"
                  style={{ display: 'flex', alignItems: 'center', padding: '10px 15px' }}
                />

                <SidebarItem
                  name="Install"
                  path={`/sites/${site.id}/install`}
                  style={{ display: 'flex', alignItems: 'center', padding: '10px 15px' }}
                />
                <SidebarItem
                  name="Popups"
                  path={`/sites/${site.id}/manage`}
                  style={{ display: 'flex', alignItems: 'center', padding: '10px 15px' }}
                />
                <SidebarItem
                  name="Widgets"
                  path={`/sites/${site.id}/widgets`}
                  style={{ display: 'flex', alignItems: 'center', padding: '10px 15px' }}
                />
                {site?.capabilities?.campaigns && (
                  <SidebarItem
                    name="Campaigns"
                    path={`/sites/${site.id}/campaigns`}
                    style={{ display: 'flex', alignItems: 'center', padding: '10px 15px' }}
                  />
                )}
                {site?.capabilities?.forms_and_surveys && (
                  <SidebarItem
                    name="Forms & Surveys"
                    path={`/sites/${site.id}/forms`}
                    style={{ display: 'flex', alignItems: 'center', padding: '10px 15px' }}
                  />
                )}
                <SidebarItem
                  name="Targeting"
                  path={`/sites/${site.id}/rules`}
                  style={{ display: 'flex', alignItems: 'center', padding: '10px 15px' }}
                />
                {site?.capabilities?.spam_shield && (
                  <SidebarItem
                    name="Spam Shield"
                    path={`/sites/${site.id}/spam-shield`}
                  />
                )}
                <div 
                  style={{
                    width: '100px',
                    height: '17px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    color: '#777777',
                    margin: '5px 0 5px 5px',
                    position: 'relative',
                    left: '0px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  •&nbsp;Your Account
                </div>
                <SidebarItem
                  name="Contacts"
                  path={`/sites/${site.id}/contacts`}
                  style={{ display: 'flex', alignItems: 'center', padding: '10px 15px' }}
                />
                <SidebarItem
                  name="Settings"
                  path={`/sites/${site.id}/settings`}
                  className="icon-settings"
                  style={{ display: 'flex', alignItems: 'center', padding: '10px 15px' }}
                />
                <div 
                  style={{
                    width: '100px',
                    height: '17px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    color: '#777777',
                    margin: '5px 0 5px 5px',
                    position: 'relative',
                    left: '0px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  •&nbsp;Help & Support
                </div>
                <SidebarItem
                  name="Video Guides"
                  path={`/video_guides?site_id=${site.id}`}
                  style={{ display: 'flex', alignItems: 'center', padding: '10px 15px' }}
                />
              </div>
              <div style={{ paddingLeft: '15px' }}>
                <HelpDialog isOpen={false} showIcon={true} />
                
                {/* Plan text */}
                <div 
                  style={{ 
                    width: '224px',
                    color: '#9F9F9F',
                    fontSize: '12px',
                    margin: '85px 0 8px 0',
                  }}
                >
                  <div 
                    style={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}
                  >
                    Plan: {`${site.plan.name} Plan`}
                  </div>
                  <div
                    style={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      marginTop: '4px'
                    }}
                  >
                    {(() => {
                      if (!site) {
                        return "Next reset: On Trial";
                      }
                      const subscription = site.stripeSubscription || 
                                          (site.stripe_subscription_id && 
                                            (window.stripeSubscriptions?.find(
                                              sub => sub.id === site.stripe_subscription_id
                                            ))
                                          );
                      
                      if (subscription && subscription.ended_at) {
                        return `Next reset: ${new Date(subscription.ended_at).toLocaleDateString('en-US', { 
                          month: 'long', 
                          day: 'numeric', 
                          year: 'numeric' 
                        })}`;
                      } else {
                        return "Next reset: On Free Trial";
                      }
                    })()}
                  </div>
                </div>

                {/* Progress Bar */}
                <div 
                  style={{ 
                    width: '224px',
                    height: '20px',
                    backgroundColor: '#EEE',
                    borderRadius: '10px',
                    margin: '8px 0 15px 0',
                    position: 'relative',
                    overflow: 'hidden'
                  }}
                >
                  {(() => {
                    const isInstalled = site.installed;
                    const hasPopup = site.has_popup;
                    const hasRules = site.has_rules;
                    const hasContactLists = site.has_contacts;
                    
                    const calculateProgress = (progress = 0, value) => {
                      return progress + (value ? 25 : 0);
                    };
                    
                    const totalProgress = [
                      isInstalled,
                      hasPopup,
                      hasRules,
                      hasContactLists,
                    ].reduce(calculateProgress, 0);
                    
                    return (
                      <>
                        <div
                          style={{
                            width: `${totalProgress}%`,
                            height: '100%',
                            backgroundColor: '#28A745',
                            borderRadius: '10px',
                            transition: 'width 0.3s ease'
                          }}
                        />
                        <div
                          style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            color: '#575757',
                            fontSize: '12px',
                            fontWeight: 'bold'
                          }}
                        >
                          {totalProgress}%
                        </div>
                      </>
                    );
                  })()}
                </div>

                {/* Button image */}
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    history.push(`/sites/${site.id}/upgrade`);
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '224px',
                    height: '36px',
                    backgroundColor: '#3CB758',
                    color: '#FFFFFF',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    padding: '0 50px 0 30px',
                    gap: '-4px'
                  }}
                >
                  <img 
                    src={ThunderIcon} 
                    alt="Thunder Icon" 
                    style={{
                      width: '8.8px',
                      height: '17px'
                    }}
                  />
                  Upgrade your plan
                </button>

                {/* Add free.png image below */}
                <img 
                  src={FreeImage} 
                  alt="Free Tier" 
                  onClick={() => window.open('https://subscribers.com/', '_blank')}
                  style={{
                    width: '100%',
                    maxWidth: '224px',
                    marginTop: '30px',
                    cursor: 'pointer',
                    border: '2px solid transparent',
                    transition: 'all 0.2s ease',
                    ':hover': {
                      borderColor: '#ED5A29'
                    }
                  }}
                />
              </div>
            </ul>
          </React.Fragment>
        )}
        {!site && (
          <div className="new-popup-wrapper">
            <NewSiteDialog isOpen={true} />
          </div>
        )}
      </div>
      <div className="sidebar-content">{props.children}</div>
    </div>
  );
}

export default withTracking(Sidebar);
